<template>
  <div v-if="editMode">
    
    <div class="field-row">
      <label>Allowed File Types</label>
      <input
        type="text"
        v-model="field.allowedFileTypes"
        class="form-control"
        placeholder="e.g., .pdf,.doc,.docx,.jpg,.png" />
      <small class="text-muted">Comma-separated file extensions (leave empty to allow all)</small>
    </div>

    <div class="fields-row">
      <div class="field-set">
        <label>Max File Size (MB)</label>
        <input
          type="number"
          v-model="field.maxFileSize"
          class="form-control"
          min="1"
          max="200"
          style="width:120px;"
          placeholder="10" />
      </div>
      <div class="field-set">
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="field.allowMultipleValues" /> Allow Multiple Files
          </label>
        </div>
      </div>
    </div>

    <div class="field-row text-right">
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="field.required" /> Required
        </label>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="vf-field-label">{{ field.fieldName }}</div>
  </div>
</template>

<script>
  export default {
    name: 'FileField',
    props: {
      field: {
        type: Object,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false
      },
    },
    mounted() {
      // Set default values if not already set
      if (!this.field.allowedFileTypes) {
        this.field.allowedFileTypes = '';
      }
      if (!this.field.maxFileSize) {
        this.field.maxFileSize = 10;
      }
      if (this.field.allowMultipleValues === undefined) {
        this.field.allowMultipleValues = false;
      }
    },
    data() {
      return {
        // Add your component data here
      };
    },
    methods: {
      // Add your component methods here
    },
  };
</script>

<style scoped>
  label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
  }

  label input[type="checkbox"] {
    margin-right: 5px;
    vertical-align: middle;
  }

  .text-muted {
    color: #6c757d;
    font-size: 0.875em;
    display: block;
    margin-top: 3px;
  }
</style>
